import { async } from '@firebase/util';
import { ref, set } from 'firebase/database';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { db } from '../firebase.init';
import img1 from "../img/coach/coach1-1.png"
import img2 from "../img/coach/coach1-2.jpg"

const JoinForm = ({ title, free, join, coach, write ,id}) => {
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        message: '',
        course: 'Life Coaching'
    });
    const [show, setShow] = useState(true);
    const [success, setSuccess] = useState('');

    const submitData = async (e) => {
        e.preventDefault();
        const { name, email, message,course } = userData;

        if (join ? name === '' || email === '' : name === '' || email === '' || message === '') {
            console.log(userData);
        } else {
            if (join) {
                set(ref(db, 'Join our newsletter/' + name), {
                    name, email
                })
                    .then(() => {
                        setShow(true);
                        setSuccess('Thank you for Joining our Newsletter.');
                        setTimeout(() => {
                            setShow(false);
                        }, 3000);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            else if (free && write) {
                set(ref(db, 'Write RK/' + name), {
                    name, email, message
                })
                    .then(() => {
                        setShow(true);
                        setSuccess('Thank you for writing me.');
                        setTimeout(() => {
                            setShow(false);
                        }, 3000);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            else {
                set(ref(db, 'Free Consultation/' + name), {
                    name, email, message,course
                })
                    .then(() => {
                        setShow(true);
                        setSuccess('Thank you for applying free consultation.');
                        setTimeout(() => {
                            setShow(false);
                        }, 3000);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
        setUserData({ name: '', email: '', message: '' })
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setUserData({ name: '', email: '', message: '' });

    }

    return (
        <div id={id}>
            {
                !coach && <div className=' bg-slate-400  w-full p-10 mt-10 font-bold' >
                    <div className=' sm:w-2/4 w-full mx-auto'>
                        <h2 className=' mb-4 font-bold text-center  text-sky-800 text-2xl'>{title}</h2>
                        <p></p>

                        <form onSubmit={submitData} className='w-[100%]'>
                            <div >
                                <p className='md:flex items-center gap-24 my-2'>
                                    <span className=' text-lg text-slate-700'>Name </span>
                                    <input className='md:w-2/3 pl-4 w-full rounded' type="text" name="name" id="" value={userData.name} onChange={(e) =>
                                        setUserData({ ...userData, name: e.target.value })} required />
                                </p>
                                <p className=' md:flex items-center gap-24 my-2'>
                                    <span className=' text-lg text-slate-700'>Email </span> <input className='md:w-2/3 pl-4 w-full rounded' type="email" name="email" id="" value={userData.email} onChange={(e) =>
                                        setUserData({ ...userData, email: e.target.value })} required /></p>

                                {
                                    free && <div>
                                        {
                                            !write ?
                                                <div>
                                                    <p className='md:flex items-center gap-5 my-2'><span className=' text-lg text-slate-700'>Choose Course </span> <select name="" id="" value={userData.course} onChange={(e) => setUserData({ ...userData, course: e.target.value })} className='md:w-2/3 pl-4 w-full rounded' required>
                                                        <option value="Life Coaching" >Life Coaching</option>
                                                        <option value="Relationship Coaching">Relationship Coaching</option>
                                                        <option value="Grief Support">Grief Support</option>
                                                        <option value="Self Development">Self Development</option>
                                                        <option value="Goal settings">Goal settings</option>
                                                    </select></p>

                                                    <p className=' md:flex items-center gap-16 my-2'><span className=' text-lg text-slate-700'>Comment </span>
                                                        <textarea name="message" id="" className='md:w-2/3 pl-4 w-full rounded' value={userData.message} onChange={(e) =>
                                                            setUserData({ ...userData, message: e.target.value })} required></textarea>
                                                    </p>
                                                </div>
                                                :
                                                <p className=' md:flex items-center gap-16 my-2'><span className=' text-lg text-slate-700'>Message </span>
                                                    <textarea name="message" id="" className='md:w-2/3 pl-4 w-full rounded' value={userData.message} onChange={(e) =>
                                                        setUserData({ ...userData, message: e.target.value })} required></textarea>
                                                </p>
                                        }
                                        {
                                            !write &&
                                            <p className=' text-center text-slate-700'>If you are in a "urgent" need Send me  a message at <a href="https://www.facebook.com/rabinandan.in/" className=' text-blue-600' target='_blank'>Facebook</a></p>
                                        }

                                    </div>
                                }
                            </div>

                            <div className='flex justify-center items-center gap-2 mt-5 mx-auto'>
                                <input className=' bg-sky-600 cursor-pointer py-1 px-4 text-white rounded' type="submit" value="Submit" />
                                <button type="reset" className=' bg-cancel cursor-pointer py-1 px-4  text-white rounded' onClick={handleCancel}>Cancel</button>
                            </div>
                            {show && <p className=' text-xl text-gray-50 text-center'>{success}</p>}
                        </form>
                    </div>
                </div>
            }

            {
                coach && <div className=' grid md:grid-cols-[20%_minmax(60%,_1fr)_20%] grid-cols-1  bg-slate-100  w-full p-10 mt-10 font-bold'>
                    <div className=' my-auto bg-slate-100 md:p-5 flex flex-col items-center'>
                        <img src={img1} className=' h-[200px]' alt="" />
                        <p className=' text-center'>Get a chance for 1-o-1  Counseling</p>
                    </div>
                    <div className=' mx-auto w-[100%] px-5'>
                        <h2 className=' mb-4 font-bold text-center  text-sky-800 text-2xl'>{title}</h2>
                        <p></p>

                        <form onSubmit={submitData} className=''>
                            <div className=''>
                                <p className='xl:flex items-center gap-[85px] my-2'><span className=' text-lg text-slate-700'>Name :</span>
                                    <input className='xl:w-2/3 pl-4 w-full  rounded' type="text" name="name" id="" value={userData.name} onChange={(e) =>
                                        setUserData({ ...userData, name: e.target.value })} required />
                                </p>
                                <p className=' xl:flex items-center gap-[89px] my-2'><span className=' text-lg text-slate-700'>Email :</span> <input className='xl:w-2/3 w-full pl-4  rounded' type="email" name="email" id="" value={userData.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} required /></p>

                                <p className='xl:flex items-center gap-[12px] my-2'><span className=' text-lg text-slate-700'>Choose Course :</span> <select name="" id="" value={userData.course} onChange={(e) => setUserData({ ...userData, course: e.target.value })} className=' xl:w-2/3 w-full pl-4  rounded' required>
                                    <option value="Life Coaching" >Life Coaching</option>
                                    <option value="Relationship Coaching">Relationship Coaching</option>
                                    <option value="Grief Support">Grief Support</option>
                                    <option value="Self Development">Self Development</option>
                                    <option value="Goal settings">Goal settings</option>
                                </select></p>

                                <div>
                                    <p className=' xl:flex items-center gap-[54px] my-2'><span className=' text-lg text-slate-700'>Comment :</span>
                                        <textarea name="" id="" className='xl:w-2/3 w-full pl-4 rounded' value={userData.message} onChange={(e) =>
                                            setUserData({ ...userData, message: e.target.value })} required></textarea>
                                    </p>

                                    <p className=' text-center text-slate-700'>If you are in a "urgent"need  Send me  a message at <a href="https://www.facebook.com/rabinandan.in/" className=' text-blue-600' target='_blank'>Facebook</a></p>
                                </div>
                            </div>

                            <div className='flex justify-center items-center gap-2 mt-5 mx-auto'>
                                <input className=' bg-sky-600 cursor-pointer py-1 px-4 text-white rounded' type="submit" value="Submit" />
                                <button type="reset" className=' bg-cancel cursor-pointer py-1 px-4  text-white rounded' onClick={handleCancel}>Cancel</button>
                            </div>

                            {show && <p className='text-xl text-gray-50 text-center'>{success}</p>}
                        </form>
                    </div>
                    <div className=' my-auto bg-slate-100 md:p-5 flex flex-col items-center'>
                        <img src={img2} alt="" className=' h-[200px]' />
                        <p>Meet your Coach now</p>
                    </div>
                </div>
            }
        </div>
    );
};

export default JoinForm;
